import { render, staticRenderFns } from "./ClusterRegistrationForm.vue?vue&type=template&id=02b057e4&"
import script from "./ClusterRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./ClusterRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports